<template>
  <lcontainer class="py-12 px-12">
    <lCrumbs :breadcrumb="breadcrumbItems" />
    <div v-for="(question, i) in surveys" :key="i" class="question mb-8">
      <div>
        <div
          class="question-head mb-4 flex justify-between text-main-color font-bold"
        >
          <h6>Question {{ i + 1 }}</h6>
        </div>
        <div class="mb-4">
          <p>{{ question.question.question_text }}</p>
          <ltextarea
            disable="true"
            v-model="question.answer"
            placeholder="Enter Answer"
          />
        </div>
      </div>
    </div>
  </lcontainer>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import isEmpty from "lodash.isempty";
export default {
  computed: {
    size() {
      return { width: 300, height: 300 };
    },
  },
  data() {
    return {
      form: {},
      errors: [],
      summary: [],
      surveys: null,
      users: null,
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/surveys",
          text: "All Surveys",
        },
        {
          disabled: true,
          to: "#",
          text: "Survey Summary",
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantSingleSurveyUserAnswer"]),
    dataIsEmpty(data) {
      return isEmpty(data);
    },
  },
  async created() {
    this.updateLoader(true);
    let surveys = await this.tenantSingleSurveyUserAnswer({
      survey_id: this.$route.params.survey_id,
      learner_id: this.$route.params.learner_id,
    });
    this.surveys = surveys;
    this.updateLoader(false);
  },
  components: {
    lcontainer: () => import("@/components/general/container"),
    LmsButton: () => import("@/components/general/button"),
    linput: () => import("@/components/general/input"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    lCharts: () => import("@/components/shared/chart/pie.vue"),
    lSurveyUser: () => import("@/components/forms/survey_user.vue"),
    lEmpty: () => import("@/components/general/Empty.vue"),
    ltextarea: () => import("@/components/general/textarea"),
  },
};
</script>
<style scoped></style>
